import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const ReportIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" /><path d="M7 16v-4M12 16V8M17 16v-6" />
    </g>
  </SvgIcon>
)

export default ReportIcon
